import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { Upload } from '../components';
import {
  UploadState,
  postUpload,
  clearUploadFile,
  clearUploadMessages,
  setUploadFilePattern,
  UploadFilePattern,
  failUpload,
  clearUpload,
} from '../modules/upload';
import { goComparisonPage, goLoginPage } from '../modules/pages';
// import { ComparisonState, clearComparision } from '../modules/comparison';
import { ComparisonState } from '../modules/comparison';
import { clearApply } from '../modules/apply';

export function mapStateToProps(state: {
  upload: UploadState,
  comparison: ComparisonState,
}) {
  const { files, fileStates, filePatterns, messages, status  } = state.upload;
  const { comparison } = state.comparison;
  return {
    comparison,
    files,
    fileStates,
    filePatterns,
    messages,
    status,
  };
}

export function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    postUpload: (index: number, file: File) => dispatch(postUpload(index, file)),
    clearUploadFile: (index: number) => dispatch(clearUploadFile(index)),
    clearUploadMessages: () => dispatch(clearUploadMessages()),
    setUploadFilePattern: (index: number, pattern: UploadFilePattern) =>
      dispatch(setUploadFilePattern(index, pattern)),
    goComparisonPage: () => {
      // dispatch(clearComparision());
      dispatch(goComparisonPage());
      dispatch(clearApply());
    },
    goLoginPage: () => {
      dispatch(goLoginPage());
      dispatch(clearUpload());
    },
    failUpload: (index: number, messages: string[], status: number) => dispatch(failUpload(index, messages, status)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Upload);



// WEBPACK FOOTER //
// ./src/containers/Upload.tsx